<template>
  <div class="staffhistoryDetail">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div
      :class="historyDetail.visitorStatus || historyDetail.auditStatus"
      class="visitStatusBox"
    >{{ historyDetail.visitorStatusName }}</div>
    <div class="content">
      <p class="content-title">{{ contentTitleOne }}</p>
      <!-- 审核记录时 -->
      <div v-if="this.$route.query.activeName === 'checkRecord' || this.$route.query.type == 'audit'" class="content-detail">
        <p>{{ historyDetail.beVisitStaffName }}</p>
        <p>公司：{{ historyDetail.beVisitCompanyName }}</p>
        <a v-if="historyDetail.auditStatus === 'WAITING_AUDIT'" @click="changeFloor">
          楼层：<span style="color: #3B86FF;">{{ historyDetail.beVisitEdificeName }}{{ historyDetail.beVisitFloorName }}</span>
        </a>
        <a v-else>楼层：{{ historyDetail.beVisitEdificeName }}{{ historyDetail.beVisitFloorName }}</a>
      </div>
      <!-- 邀约记录时 -->
      <div v-if="this.$route.query.activeName === 'inviteReord' || this.$route.query.type == 'invite'" class="content-detail">
        <p>{{ historyDetail.name }}</p>
        <p>手机号：{{ historyDetail.phone }}</p>
        <p v-for="item in extraFields" :key="item.id">{{ item.displayName }}：{{ historyDetail[item.fieldName] || '无' }}</p>
      </div>
    </div>
    <div class="content">
      <p class="content-title">{{ contentTitleTwo }}</p>
      <div v-if="this.$route.query.activeName === 'checkRecord' || this.$route.query.type == 'audit'" class="content-reason">
        <p class="content-reasonItem">
          <span>头像</span>
          <span class="faceImg">
            <svg-icon v-if="!historyDetail.faceImg" icon-class="avatar" />
            <img v-else :src="baseURL + historyDetail.faceImg" class="_avatar" alt>
          </span>
        </p>
        <p class="content-reasonItem">
          <span>姓名</span>
          <span>{{ historyDetail.name }}</span>
        </p>
        <p class="content-reasonItem">
          <span>手机号</span>
          <span>{{ historyDetail.phone }}</span>
        </p>
        <p class="content-reasonItem">
          <span>公司名称</span>
          <span>{{ historyDetail.company }}</span>
        </p>
        <p class="content-reasonItem">
          <span>来访事由</span>
          <span>{{ historyDetail.reason }}</span>
        </p>
        <p class="content-reasonItem">
          <span>来访时间</span>
          <span>{{ historyDetail.visitDate }}</span>
        </p>
        <p class="content-reasonItem">
          <span>离访时间</span>
          <span>{{ historyDetail.endVisitDate }}</span>
        </p>
        <p v-for="item in extraFields" :key="item.id" class="content-reasonItem">
          <span>{{ item.displayName }}</span>
          <span>{{ historyDetail[item.fieldName] || '无' }}</span>
        </p>
      </div>
      <div v-else class="content-reason">
        <p class="content-reasonItem">
          <span>来访事由</span>
          <span>{{ historyDetail.reason }}</span>
        </p>
        <p class="content-reasonItem">
          <span>来访时间</span>
          <span>{{ historyDetail.visitDate }}</span>
        </p>
        <p class="content-reasonItem">
          <span>离访时间</span>
          <span>{{ historyDetail.endVisitDate }}</span>
        </p>
      </div>
    </div>
    <div v-if="historyDetail.team && acpyVisitorsArr.length > 0" class="content">
      <!--  v-if="this.$route.query.type == 'invite' || this.$route.query.activeName == 'inviteReord'" -->
      <p class="content-title">陪同访客</p>
      <div v-for="(item,index) in acpyVisitorsArr" :key="index" class="content-reason has-small-magb">
        <div class="tip-status" :class="item.visitorStatus">{{ item.visitorStatus | formatStatus }}</div>
        <p class="content-reasonItem has-status">
          <span>姓名</span>
          <span>{{ item.name }}</span>
        </p>
        <p class="content-reasonItem">
          <span>手机号</span>
          <span>{{ item.phone }}</span>
        </p>
        <p v-for="son in extraFields" :key="son.id" class="content-reasonItem">
          <span>{{ son.displayName }}</span>
          <span>{{ item[son.fieldName] || '无' }}</span>
        </p>
      </div>
    </div>
    <div class="content">
      <p class="content-title">来访动态</p>
      <van-steps direction="vertical" :active="historyDetail.statusLogs.length - 1">
        <van-step v-for="son in historyDetail.statusLogs">
          <div>{{ son.statusInfo }}</div>
          <p>{{ son.createTime }}</p>
        </van-step>
      </van-steps>
    </div>
    <div v-if="historyDetail.remark" class="stall_tip">{{ `温馨提示：${historyDetail.remark}` }}</div>
    <div v-if="historyDetail.auditStatus === 'WAITING_AUDIT'" class="btns">
      <div @click="refuseCheck">拒绝</div>
      <div @click="passCheck">通过</div>
    </div>
    <div v-if="filterShare()" class="btns">
      <div @click="onShare">分享邀请函</div>
      <div class="url" @click="onCopy">复制邀请函链接</div>
    </div>
    <div v-if="$route.query.activeName !== 'history'">
    <van-button
      v-show="(historyDetail.visitorStatus === 'WAITING_AUDIT' || historyDetail.visitorStatus === 'WAITING_VERIFY' || historyDetail.visitorStatus === 'WAITING_VISIT') && this.$route.query.activeName !== 'checkRecord' && this.$route.query.type !== 'audit'"
      :disabled="false"
      class="sub_btn"
      style="margin: 0.2rem auto"
      type="info"
      @click="cancelInvite"
    >取消邀约</van-button>
    <van-button
      v-show="(historyDetail.visitorStatus === 'WAITING_VISIT' || historyDetail.visitorStatus === 'WAITING_VERIFY' || historyDetail.visitorStatus === 'VISITING') && (this.$route.query.type == 'audit')"
      :disabled="false"
      class="sub_btn"
      style="margin: 0.2rem auto"
      type="info"
      @click="cancelInvite"
    >取消预约</van-button>
    <van-button
      v-show="(historyDetail.visitorStatus === 'CANCEL' || historyDetail.visitorStatus === 'FINISH' || historyDetail.visitorStatus === 'UNVISIT' || historyDetail.visitorStatus === 'AUDIT_FAIL') && (historyDetail.visitorStatus!=='VISITING') && (this.$route.query.activeName !== 'checkRecord')"
      :disabled="false"
      class="sub_btn"
      style="margin: 0.2rem auto"
      type="info"
      @click="reInvite"
    >重新邀约</van-button>
    <van-button
      v-show="historyDetail.visitorStatus == 'VISITING' || historyDetail.visitorStatus === 'OUTTIME_VISIT'"
      :disabled="false"
      class="sub_btn"
      style="margin: 0.2rem auto"
      type="info"
      @click="endInvite"
    >结束邀约</van-button>
    </div>
    <div v-if="showTips" class="cover">
      <svg-icon icon-class="share" class-name="share" />
      <svg-icon icon-class="share_btn" class-name="shareBtn" @click="showTips = false" />
    </div>
    <van-dialog v-model="showRefuseDialog" title="温馨提示" show-cancel-button @confirm="confirmRefuse">
      <van-cell-group>
        <van-field v-model="message" class="control" rows="1" autosize type="textarea" placeholder="请输入拒绝原因" />
      </van-cell-group>
    </van-dialog>
    <van-dialog
      v-model="showCancleDialog"
      title="温馨提示"
      show-cancel-button
      @confirm="confirmCancel"
    >
      <van-cell-group>
        <van-field v-model="message" rows="1" class="control" autosize type="textarea" placeholder="请输入取消原因" style="text-align: left" />
      </van-cell-group>
    </van-dialog>
    <van-dialog v-model="showEndDialog" title="温馨提示" show-cancel-button @confirm="confirmEnd">
      <van-cell-group style="padding: 0.24rem; line-height: 0.24rem;font-size: 0.13rem;">结束访问将认为访客已离开并注销通行权限，是否确认结束访问？</van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import {
  GetCheckRecordDetail,
  GetInviteReordDetail,
  ConfirmRefuse,
  inviteShare,
  inviteOperate
} from '@/api/user';
import config from '@/common/config';
import { Step, Steps } from 'vant';
import Clipboard from 'clipboard';
import wx from 'weixin-js-sdk';
import { getReasons, wechatSignature } from '@/api/home';
export default {
  name: 'StaffHistoryDetail',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  filters: {
    // 过滤访客状态
    formatStatus(val) {
      const statusMap = {
        CANCEL: '已取消',
        WAITING_AUDIT: '待审核',
        WAITING_VERIFY: '待验证',
        AUDIT_FAIL: '未过审',
        WAITING_VISIT: '待到访',
        VISITING: '访问中',
        FINISH: '已完成',
        UNVISIT: '过期未到访',
        OUTTIME_VISIT: '超时逗留',
        AUDIT_PASSED: '已通过',
        AUDIT_REFUSED: '已拒绝',
        OUTTIME_AUDIT: '超时未审核'
      };
      return statusMap[val];
    }
  },
  data() {
    return {
      baseURL:
        process.env.NODE_ENV === 'development'
          ? config.baseUrl.dev
          : config.baseUrl.pro,
      subHead: '详情',
      contentTitleTwo: '',
      contentTitleOne: '',
      visitStatus: '访问中',
      showRefuseDialog: false,
      showEndDialog: false,
      showCancleDialog: false,
      message: '',
      historyDetail: {
        statusLogs: []
      },
      acpyVisitorsArr: [
        {
          name: '张大大',
          phone: '13507245734',
          carNumber: '',
          status: 'CANCEL'
        },
        {
          name: '张大大',
          phone: '13507245734',
          carNumber: '粤AC527',
          status: 'WAITING_VISIT'
        },
        {
          name: '张大大',
          phone: '13507245734',
          status: 'FINISH',
          carNumber: ''

        }
      ],
      showTips: false,
      showShareBtn: false,
      inviteUrl: '',
      extraFields: []
    };
  },
  created() {
    // 从消息模板进来
    if (this.$route.query.type) {
      switch (this.$route.query.type) {
        case 'audit':
          this.getCheckRecordDetail(this.$route.query.id);
          this.contentTitleTwo = '来访信息';
          this.contentTitleOne = '被访人信息';
          break;
        case 'invite':
          this.getInviteReordDetail(this.$route.query.id);
          this.contentTitleTwo = '来访事由及时间';
          this.contentTitleOne = '主访客信息';
          this.showShareBtn = true;
          break;
        default:
          break;
      }
    } else {
      // 从历史记录进来
      this.getHistoryDetail(this.$route.query.activeName);
      this.contentTitleTwo = this.$route.query.activeName === 'checkRecord' ? '来访信息' : '来访事由及时间';
      this.contentTitleOne = this.$route.query.activeName === 'checkRecord' ? '被访人信息' : '主访客信息';
      if (this.$route.query.activeName === 'inviteReord') {
        this.showShareBtn = true;
      }
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   // next(vm => {
  //   //   vm.fromPage = from
  //   // })
  // },
  methods: {
    goBack() {
      // this.$router.go(-1)
      this.$router.push({ name: 'staffHistory' });
      this.$store.dispatch('setFloorInfo', { data: {}});
    },
    filterShare() {
      const { visitorStatus } = this.historyDetail;
      if (this.showShareBtn && (visitorStatus === 'WAITING_VERIFY' || visitorStatus === 'WAITING_VISIT')) {
        return true;
      } else {
        return false;
      }
    },
    getHistoryDetail(activeName) {
      switch (activeName) {
        case 'checkRecord':
          this.getCheckRecordDetail(this.$route.query.id);
          break;
        case 'history':
          this.getCheckRecordDetail(this.$route.query.id);
          break;
        case 'inviteReord':
          this.getInviteReordDetail(this.$route.query.id);
          break;
        default:
          break;
      }
    },
    // 员工审核记录详情
    getCheckRecordDetail(id) {
      const data = {
        id: id
      };
      GetCheckRecordDetail(data).then(response => {
        this.historyDetail = response.data;
        // this.historyDetail.visitDate = this.historyDetail.visitDate.slice(0, -3);
        if (response.data.auditStatus === 'WAITING_AUDIT') {
          const info = this.$store.state.floorInfo;
          if (info.id) {
            this.$store.dispatch('setFloorInfo', { data: info });
            this.historyDetail.beVisitEdificeName = info.parentName;
            this.historyDetail.beVisitFloorName = info.name;
          } else {
            info.id = this.historyDetail.beVisitFloorId;
            info.parentId = this.historyDetail.beVisitEdificeId;
            info.parentName = this.historyDetail.beVisitEdificeName;
            info.name = this.historyDetail.beVisitFloorName;
            this.$store.dispatch('setFloorInfo', { data: info });
          }
        }
        getReasons({}).then(res => {
          // 假设 res.data.extraFields 可能存在也可能不存在，且其内部的 ASK 和 APPOINTMENT 也可能不存在
          const askArray = res.data.extraFields.ASK ? res.data.extraFields.ASK : [];
          const appointmentArray = res.data.extraFields.APPOINTMENT ? res.data.extraFields.APPOINTMENT : [];

          // 将两个数组合并为一个新数组，然后创建一个新的 Set
          this.extraFields = new Set(response.beInvite ? [...askArray] : [...appointmentArray]);
        });
      });
    },
    // 员工邀约记录详情
    getInviteReordDetail(id) {
      const data = {
        id: id
      };
      GetInviteReordDetail(data).then(response => {
        this.historyDetail = response.data;
        // this.historyDetail.visitDate = this.historyDetail.visitDate.slice(0, -3);
        this.acpyVisitorsArr = response.data.retinues;
        if (this.showShareBtn && (response.data.visitorStatus === 'WAITING_VERIFY' || response.data.visitorStatus === 'WAITING_VISIT')) {
          inviteShare({ id: this.$route.query.id }).then(res => {
            if (res.data.done) {
              this.inviteUrl = res.data.url;
            }
          });
        }
        getReasons({}).then(res => {
          // 假设 res.data.extraFields 可能存在也可能不存在，且其内部的 ASK 和 APPOINTMENT 也可能不存在
          const askArray = res.data.extraFields.ASK ? res.data.extraFields.ASK : [];
          const appointmentArray = res.data.extraFields.APPOINTMENT ? res.data.extraFields.APPOINTMENT : [];

          // 将两个数组合并为一个新数组，然后创建一个新的 Set
          this.extraFields = new Set(response.beInvite ? [...askArray] : [...appointmentArray]);
        });
      });
    },
    // 拒绝审核
    refuseCheck() {
      this.showRefuseDialog = true;
    },
    // 提交拒绝审核
    confirmRefuse() {
      const info = this.$store.state.floorInfo;
      const data = {
        id: this.historyDetail.id,
        pass: false,
        reason: this.message,
        beVisitFloorId: info.id
      };
      ConfirmRefuse(data).then(response => {
        this.showRefuseDialog = false;
        if (response.code === 200) {
          this.$toast.success('提交成功');
          // this.getHistoryDetail(this.$route.query.activeName)
          setTimeout(() => {
            location.reload();
          }, 500);
          this.$store.dispatch('setFloorInfo', { data: {}});
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    passCheck() {
      const info = this.$store.state.floorInfo;
      const data = {
        id: this.historyDetail.id,
        pass: true,
        reason: this.message,
        beVisitFloorId: info.id
      };
      ConfirmRefuse(data).then(response => {
        if (response.code === 200) {
          this.$toast.success('提交成功');
          // this.getHistoryDetail(this.$route.query.activeName)
          setTimeout(() => {
            location.reload();
          }, 500);
          this.$store.dispatch('setFloorInfo', { data: {}});
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    changeFloor() {
      this.$router.push({ name: 'changeFloor' });
    },
    onShare() {
      this.showTips = true;
      const url = window.location.href.split('#');
      wechatSignature({ url: url[0] }).then(res => {
        // 要显示的菜单项，所有menu项见附录3
        // wx.config({
        //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        //   appId: res.data.appId, // 必填，公众号的唯一标识
        //   timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        //   nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        //   signature: res.data.signature, // 必填，签名
        //   jsApiList: ['updateAppMessageShareData', 'showMenuItems'] // 必填，需要使用的JS接口列表
        // });
        this.getShare();
      });
    },
    onCopy() {
      const that = this;
      const clipboard = new Clipboard('.url', {
        text: function() {
          return that.inviteUrl;
        }
      });
      clipboard.on('success', e => {
        this.$toast({
          message: '复制成功'
        });
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        this.$toast({
          message: '复制失败'
        });
        clipboard.destroy();
      });
    },
    getShare() {
      // 10023325
      inviteShare({ id: this.$route.query.id }).then(res => {
        if (res.data.done) {
          this.inviteUrl = res.data.url;
          wx.showMenuItems({
            menuList: ['menuItem:share:appMessage'] // 要显示的菜单项，所有menu项见附录3
          });
          wx.updateAppMessageShareData({
            title: res.data.title, // 分享标题
            desc: res.data.desc, // 分享描述
            link: res.data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: res.data.image, // 分享图标
            success: function() {
              // 设置成功
            }
          });
        }
      });
    },
    cancelInvite() {
      this.showCancleDialog = true;
    },
    confirmCancel() {
      const data = {
        id: this.historyDetail.id,
        reason: this.message,
        status: 'CANCEL'
      };
      inviteOperate(data).then(response => {
        this.showCancleDialog = false;
        if (response.code === 200) {
          this.$toast.success('操作成功');
          // this.getHistoryDetail(this.$route.query.activeName)
          setTimeout(() => {
            location.reload();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    endInvite() {
      this.showEndDialog = true;
    },
    confirmEnd() {
      const data = {
        id: this.historyDetail.id,
        reason: '',
        status: 'CANCEL'
      };
      inviteOperate(data).then(response => {
        this.showEndDialog = false;
        if (response.code === 200) {
          this.$toast.success('操作成功');
          // this.getHistoryDetail(this.$route.query.activeName)
          setTimeout(() => {
            location.reload();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    reInvite() {
      this.historyDetail.floorName = this.historyDetail.beVisitEdificeName + this.historyDetail.beVisitFloorName;
      const inviteInfo = JSON.stringify(this.historyDetail);
      // sessionStorage.setItem('inviteInfo', JSON.stringify(this.historyDetail))
      this.$router.push({ name: 'invite', params: { inviteInfo: inviteInfo }});
    }
  }
};
</script>

<style lang="less">
.staffhistoryDetail {
  min-height: 100vh;
  padding-bottom: 0.2rem;
  position: relative;
  .content {
    //  padding: 0rem 0.15rem;
    padding-bottom: 0.1rem;
    .content-title,
    .visitStatus {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0rem 0.15rem;
    }
    .content-detail,
    .content-reason {
      font-size: 0.17rem;
      color: #333;
      background: #fff;
      padding: 0.18rem 0.15rem;
    }
    .content-detail p:not(:last-child) {
      margin-bottom: 0.1rem;
    }
    .content-reason {
      padding: 0rem 0.15rem;
      .content-reasonItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.55rem;
        line-height: 0.55rem;
        .faceImg {
          width: 0.33rem;
          height: 0.33rem;
          line-height: 0.33rem;
          .svg-icon {
            width: 100%;
            height: 100%;
          }
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }
      .content-reasonItem:not(:last-child) {
        border-bottom: 1px solid #e5e5e5;
      }
    }
     .has-small-magb{
        position: relative;
        margin-bottom: 0.1rem;
        .content-reasonItem[class~='has-status']{
          height:0.73rem;
        }
        .tip-status{
          width: 0.65rem;
          height: 0.2rem;
          line-height: 0.2rem;
          text-align: center;
          border-radius: 14px 0px 0px 14px;
          color: #fff;
          font-size: .14rem;
          position: absolute;
          right: 0px;
           &.CANCEL,
          &.UNVISIT,
          &.AUDIT_FAIL,
          &.OUTTIME_AUDIT {
            background-color: rgba(51, 51, 51, 0.5);
          }

          &.WAITING_AUDIT,
          &.WAITING_VERIFY {
            background-color: #f2b230;
          }

          &.OUTTIME_VISIT,
          &.AUDIT_REFUSED {
            background-color: #f76260;
          }

          &.VISITING,
          &.WAITING_VISIT {
            background-color: #3b86ff;
          }

          &.FINISH,
          &.AUDIT_PASSED {
            background-color: #2dcc2c;
          }
        }

      }
  }
  .control {
    .van-field__control {
      text-align: left;
    }
  }
  .btns {
    display: flex;
    justify-content: space-between;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
    padding: 0rem 0.28rem;
    > div {
      width: 1.37rem;
      height: 0.47rem;
      font-size: 0.18rem;
      color: #fff;
      border-radius: 5px;
      line-height: 0.47rem;
      text-align: center;
    }
    div:first-child {
      background: rgba(255, 190, 0, 1);
      border: 2px solid rgba(5, 5, 5, 0.0823);
    }
    div:last-child {
      background: rgba(45, 204, 44, 1);
      border: 2px solid rgba(5, 5, 5, 0.0823);
    }
  }

  .cover {
    position: absolute;
    opacity: 0.5;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    .share {
      position: absolute;
      right: 20px;
      top: 10px;
      width: 2rem;
      height: 2rem;
    }
    .shareBtn {
      position: absolute;
      right: 0;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      width: 2rem;
      height: 2rem;
    }
  }
}
.content-detail:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, 1);
}
 .stall_tip{
    padding: 0 0.15rem;
    font-size: 0.14rem;
    color: #888;
    margin-top: 0.1rem;
  }
</style>
